import React from "react";
import { Mail, Phone, MapPin, Linkedin, Instagram, Facebook } from "lucide-react";
import Seo from "../components/Seo";
import SectionEyebrow from "../components/SectionEyebrow";
import RevealOnScroll from "../components/RevealOnScroll";
import ContactForm from "../components/ContactForm";
import { BRAND, SOCIAL } from "../data/content";

const iconMap = { Linkedin, Instagram, Facebook };

const Contatti = () => {
  return (
    <>
      <Seo
        title="Contatti OnSports — consulenza brand sportivi | OnSports"
        description="Scrivi a OnSports per una consulenza in Impact Strategy, sponsorship, content, performance. Sede Via Jacopo Dal Verme 7, Milano. Rispondiamo in 24 ore lavorative."
        path="/contatti"
      />

      <section
        className="bg-dodgers text-galactico pt-40 pb-20 md:pt-52 md:pb-24"
        data-testid="contatti-hero"
      >
        <div className="container-os">
          <RevealOnScroll>
            <SectionEyebrow>Contatti</SectionEyebrow>
          </RevealOnScroll>
          <RevealOnScroll delay={0.1}>
            <h1 className="display-h1 mt-8 max-w-[20ch]">
              Parliamone.<br />
              <span className="text-lime">Dal primo brief</span> alla scorecard.
            </h1>
          </RevealOnScroll>
          <RevealOnScroll delay={0.2}>
            <p className="mt-8 body-lg opacity-85 max-w-[60ch]">
              Rispondiamo a tutte le richieste entro 24h. Nessun call-center, nessun
              pitch automatico — ti scrive direttamente uno dei nostri partner.
            </p>
          </RevealOnScroll>
        </div>
      </section>

      <section className="section-pad bg-galactico text-dodgers" data-testid="contatti-main">
        <div className="container-os">
          <div className="grid grid-cols-12 gap-8 md:gap-12">
            <div className="col-span-12 md:col-span-5 space-y-10">
              <RevealOnScroll>
                <div data-testid="contatti-sede">
                  <SectionEyebrow>Sede</SectionEyebrow>
                  <address className="not-italic mt-4 flex items-start gap-3 text-[1.0625rem] leading-relaxed">
                    <MapPin size={20} className="mt-1 flex-shrink-0 text-lime" />
                    <span>
                      {BRAND.legalName}
                      <br />
                      {BRAND.addressStreet}
                      <br />
                      {BRAND.addressCity}
                    </span>
                  </address>
                </div>
              </RevealOnScroll>
              <RevealOnScroll delay={0.05}>
                <div>
                  <h3 className="font-condensed uppercase tracking-widest text-xs opacity-60 mb-3">
                    Email
                  </h3>
                  <a
                    className="flex items-center gap-3 text-[1.0625rem] hover:text-mandrogni"
                    href={`mailto:${BRAND.email}`}
                  >
                    <Mail size={20} className="text-lime" />
                    {BRAND.email}
                  </a>
                </div>
              </RevealOnScroll>
              <RevealOnScroll delay={0.1}>
                <div>
                  <h3 className="font-condensed uppercase tracking-widest text-xs opacity-60 mb-3">
                    Telefono
                  </h3>
                  <a
                    className="flex items-center gap-3 text-[1.0625rem] hover:text-mandrogni"
                    href={`tel:${BRAND.phone.replace(/\s+/g, "")}`}
                  >
                    <Phone size={20} className="text-lime" />
                    {BRAND.phone}
                  </a>
                </div>
              </RevealOnScroll>
              <RevealOnScroll delay={0.15}>
                <div>
                  <h3 className="font-condensed uppercase tracking-widest text-xs opacity-60 mb-3">
                    Social
                  </h3>
                  <div className="flex items-center gap-3">
                    {SOCIAL.map((s) => {
                      const Icon = iconMap[s.icon];
                      return (
                        <a
                          key={s.label}
                          href={s.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`OnSports su ${s.label}`}
                          className="w-10 h-10 inline-flex items-center justify-center border border-dodgers/30 hover:bg-dodgers hover:text-galactico transition-colors"
                        >
                          {Icon && <Icon size={16} />}
                        </a>
                      );
                    })}
                  </div>
                </div>
              </RevealOnScroll>
            </div>
            <div className="col-span-12 md:col-span-7">
              <RevealOnScroll delay={0.1}>
                <ContactForm tone="dark" />
              </RevealOnScroll>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contatti;
